export default "__VITE_ASSET__p2Aejw7t__"